
/* hl-image-fix.js v8 - Higher specificity fix for offer boxes */
(function(){
  var css = `
@media(max-width:900px){

  /* ===== HERO LAYOUT ===== */
  body .pdp-hero__inner{
    display:flex!important;
    flex-direction:column!important;
    gap:0!important;
    grid-template-columns:unset!important;
    max-width:100vw!important;
    overflow-x:hidden!important;
  }
  body .pdp-hero__image-col{
    width:100%!important;
    max-width:100vw!important;
    order:1!important;
    position:static!important;
    padding:0!important;
    box-sizing:border-box!important;
  }
  body .pdp-hero__info-col{
    width:100%!important;
    max-width:100vw!important;
    order:2!important;
    padding:16px!important;
    box-sizing:border-box!important;
  }
  body .pdp-hero__image-main,
  body .pdp-hero__image-main img,
  body #hero-main-img{
    width:100%!important;
    max-width:100vw!important;
    height:auto!important;
    max-height:380px!important;
    object-fit:cover!important;
    object-position:top center!important;
    display:block!important;
  }

  /* ===== OFFER BOXES - higher specificity to override global rules ===== */
  /* The section CSS has .offer-box { display:block } OUTSIDE any media query */
  /* Using body .offer-box gives us higher specificity to win */
  body .bundle-offers{
    display:flex!important;
    flex-direction:column!important;
    gap:10px!important;
    padding:0!important;
    width:100%!important;
    box-sizing:border-box!important;
  }

  /* Each offer box: column layout (info row on top, expanded gifts below) */
  body .offer-box{
    display:flex!important;
    flex-direction:column!important;
    gap:8px!important;
    width:100%!important;
    max-width:100%!important;
    box-sizing:border-box!important;
    padding:12px!important;
    overflow:visible!important;
    position:relative!important;
  }

  /* The top row of each offer box: image + label + price in a row */
  body .offer-info{
    display:flex!important;
    flex-direction:row!important;
    align-items:center!important;
    gap:10px!important;
    width:100%!important;
    flex:unset!important;
    min-width:unset!important;
  }

  /* Bottle image */
  body .offer-img{
    width:60px!important;
    height:auto!important;
    max-width:60px!important;
    max-height:80px!important;
    object-fit:contain!important;
    flex-shrink:0!important;
    display:block!important;
  }

  /* Label text */
  body .offer-label{
    flex:1!important;
    min-width:0!important;
  }

  /* Price block - sits to the right of label */
  body .price-var{
    display:flex!important;
    flex-direction:column!important;
    align-items:flex-end!important;
    gap:2px!important;
    flex-shrink:0!important;
    margin-left:auto!important;
  }

  /* Most Popular / Best Value badge */
  body .text-badge{
    position:static!important;
    display:inline-block!important;
    align-self:flex-start!important;
    margin-left:70px!important;
  }

  /* Expanded gift details (shown in active box) */
  body .offer-gifts-expanded{
    width:100%!important;
    box-sizing:border-box!important;
    padding:8px 0 0 0!important;
    border-top:1px solid #e7e7e7!important;
    margin-top:4px!important;
  }

  body .gift-detail-item{
    display:flex!important;
    flex-direction:row!important;
    align-items:flex-start!important;
    gap:8px!important;
    padding:6px 0!important;
    width:100%!important;
    box-sizing:border-box!important;
  }

  body .gift-detail-text{
    flex:1!important;
    min-width:0!important;
  }

  body .gifts-detail-divider{
    font-size:11px!important;
    text-align:center!important;
    padding:6px 0!important;
  }

  /* ===== GIFTS UNLOCKED SECTION ===== */
  body .gifts-unlocked-container,
  body .gifts-unlocked-wrap{
    width:100%!important;
    max-width:100%!important;
    box-sizing:border-box!important;
    padding:10px 12px!important;
    overflow:visible!important;
  }
  body .gifts-unlocked-row{
    display:grid!important;
    grid-template-columns:repeat(2,1fr)!important;
    gap:8px!important;
    width:100%!important;
    box-sizing:border-box!important;
  }
  body .gift-card{
    display:flex!important;
    flex-direction:column!important;
    align-items:center!important;
    text-align:center!important;
    width:100%!important;
    min-width:0!important;
    box-sizing:border-box!important;
    padding:8px!important;
  }
  body .gift-card__img{
    width:72px!important;
    height:72px!important;
    max-width:72px!important;
    max-height:72px!important;
    object-fit:contain!important;
    display:block!important;
    margin:0 auto!important;
  }
  body .gift-card__unlocked{
    display:flex!important;
    flex-direction:column!important;
    align-items:center!important;
    gap:4px!important;
  }

  /* ===== PREVENT FULL-WIDTH IMAGES ===== */
  /* The section CSS has img { max-width:100% } outside media query */
  /* Gift card images should NOT be full width */
  body .gift-card img,
  body .gift-card__img{
    max-width:72px!important;
    width:72px!important;
  }

  /* ===== UGC MARQUEE ===== */
  body .ts-marquee-wrap{
    width:100%!important;
    max-width:100vw!important;
    overflow:hidden!important;
    box-sizing:border-box!important;
  }
  body .ts-img{
    height:200px!important;
    width:auto!important;
    max-width:none!important;
    object-fit:cover!important;
    flex-shrink:0!important;
  }

  /* ===== TESTIMONIAL CARDS ===== */
  body .testi-card{
    width:calc(100vw - 32px)!important;
    max-width:calc(100vw - 32px)!important;
    box-sizing:border-box!important;
  }

  /* ===== GENERAL OVERFLOW FIX ===== */
  body,html{
    overflow-x:hidden!important;
    max-width:100vw!important;
  }
}
`;

  var styleEl = document.getElementById('hl-mobile-fix-final');
  if(!styleEl){
    styleEl = document.createElement('style');
    styleEl.id = 'hl-mobile-fix-final';
    document.head.appendChild(styleEl);
  }
  styleEl.textContent = css;
  console.log('[hl-fix v8] injected, length:', css.length);
})();
